import React from 'react';
import '../styles/landing.css';

const Stats = () => {
  return (
    <section className="stats premium-stats">
      <div className="container">
        <h2 className="section-title">PrepLetter by the Numbers</h2>
        <p className="section-subtitle">
          See why consistent practice with PrepLetter makes a difference
        </p>
        <div className="stats-grid">
          <div className="stat-item fade-in-up">
            <div className="feature-icon" style={{ background: 'linear-gradient(135deg,#10b981,#3b82f6)' }}>📚</div>
            <h3>100+</h3>
            <p>PrepLetters across<br />4 programming languages</p>
          </div>
          <div className="stat-item fade-in-up">
            <div className="feature-icon" style={{ background: 'linear-gradient(135deg,#3b82f6,#10b981)' }}>⏱️</div>
            <h3>3-5</h3>
            <p>Minutes daily<br />investment</p>
          </div>
          <div className="stat-item fade-in-up">
            <div className="feature-icon" style={{ background: 'linear-gradient(135deg,#f59e0b,#10b981)' }}>⚡</div>
            <h3>0</h3>
            <p>Time waste<br />while learning</p>
          </div>
          <div className="stat-item fade-in-up">
            <div className="feature-icon" style={{ background: 'linear-gradient(135deg,#10b981,#f59e0b)' }}>✅</div>
            <h3>100%</h3>
            <p>Interview-focused<br />content</p>
          </div>
          <div className="stat-item fade-in-up">
            <div className="feature-icon" style={{ background: 'linear-gradient(135deg,#3b82f6,#f59e0b)' }}>🧘‍♂️</div>
            <h3>0</h3>
            <p>Burnout<br />from practice</p>
          </div>
          <div className="stat-item fade-in-up">
            <div className="feature-icon" style={{ background: 'linear-gradient(135deg,#f59e0b,#3b82f6)' }}>🔋</div>
            <h3>0</h3>
            <p>Energy loss<br />while learning</p>
          </div>
        </div>
        
        <div className="premium-highlight">
          <h3>🎉 Limited Time: Premium Features Completely FREE</h3>
          <p>All advanced features included at no cost. Just verify your email and start learning!</p>
        </div>
      </div>
    </section>
  );
};

export default Stats;
